# Multi-select variant of Select2Mixin, similar to custom select2 inputs
# The base Select2Mixin sets `data` in selectOptions which conflicts with
# multi-select mode (select2 ignores <option> elements when `data` is set),
# so we strip it here to let the collection prop populate options via the template.
import Select2Mixin from './select2_mixin.js.coffee'

Select2MultiMixin =
  extends: Select2Mixin
  methods:
    selectOptions: ->
      opts = Select2Mixin.methods.selectOptions.call(this)
      delete opts.data
      opts

export default Select2MultiMixin
